import logger from "@next/core-logger"
import {MessageBanner, MessageBannerInitial} from "models/messageBanner"
import {getMessageBannerData} from "../../api/messageBanner"

export const SET_MESSAGEBANNER = "SET_MESSAGEBANNER"

export type MessageBannerDuckState = MessageBanner

export const initialState: MessageBanner = {
    type: "",
    externalPageId: "",
    title: "",
    locale: "",
    placements: [],
}
interface Actions {
    type: typeof SET_MESSAGEBANNER
    payload: MessageBannerInitial
}

export const getMessageBannerThunk = () => async (dispatch: any, getState) => {
    try {
        const state = getState()
        const {
            settings: {coreMediaRelativeUrl, messageBannerPath, coreMediaAuthTokenName, coreMediaAuthTokenValue},
            request: {headers, cleanSiteUrl},
        } = state
        const realm = headers["x-next-realm"] as string
        const territory = headers["x-next-territory"] as string
        const language = headers["x-next-language"] as string

        const response = await getMessageBannerData(
            coreMediaRelativeUrl,
            messageBannerPath,
            coreMediaAuthTokenName,
            coreMediaAuthTokenValue,
            realm,
            territory,
            language,
            cleanSiteUrl,
        )

        dispatch({
            type: SET_MESSAGEBANNER,
            payload: response,
        })
    } catch (e) {
        logger.error(e)
    }
}

const reducer = (state: MessageBanner = initialState, action): MessageBanner => {
    const {payload} = action
    switch (action.type) {
        case SET_MESSAGEBANNER:
            return {
                ...state,
                ...payload.data,
            }
        default:
            return state
    }
}

export default reducer
